import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { merge, get } from 'lodash';
import { reduxForm, formValueSelector } from 'redux-form';
import { fetchEntity, updateEntityForm, addNewWorkOrderToEditForm, addNewCustomChannelToEditForm, cloneExistingWorkOrderToEditForm, resetWorkOrderToMatchBrandEdit, clearSearchForOpportunities, switchAllWorkOrderPlatformsEdit, clearEntity } from 'services/entities/duck';
import { push } from 'connected-react-router';
import EditEntityForm from 'components/organisms/entity/edit/Form';
import { fetchList as fetchBrandList } from 'services/brands/duck';
// import { CHANNEL_DS_CONFIG } from 'constants/channels';
import { ENTITY_PLATFORMS } from 'constants/entityPlatforms';
import { getDefaultEnabledChannels, supportedChannelNamesList } from 'helpers/channels';

const formName = 'editEntity';

class EditEntityContainer extends Component {
    constructor(props) {
        super(props);

        // this.setAllChannelDataSources = this.setAllChannelDataSources.bind(this);
        this.updateEntityChannelConfigWithBrand = this.updateEntityChannelConfigWithBrand.bind(this);
        this.selectOverrideBrandAdvancedOptions = this.selectOverrideBrandAdvancedOptions.bind(this);
        this.selectOverrideBrandDisplayConfiguration = this.selectOverrideBrandDisplayConfiguration.bind(this);
    }

    getRouteEntityId() {
        return this.props.match.params.id;
    }

    getEntityId() {
        return this.props.entityId;
    }

    componentDidMount() {
        if (this.getEntityId()) {
            this.props.clearEntity({});
        }
        const entityId = this.getRouteEntityId();
        this.props.clearSearchForOpportunities();
        if (this.props.fetchEntity && entityId) {
            this.props.fetchEntity({ entityId });
        }
    }

    componentDidUpdate(prevProps) {
        if (
            (
                this.props.selectedOverrideBrandEnabledChannels !== prevProps.selectedOverrideBrandEnabledChannels
            ) || (
                this.props.selectedBrandId !== prevProps.selectedBrandId
                && !this.props.selectedOverrideBrandEnabledChannels
            )
        ) {
            const brand = this.props.brands.find(singleBrand => singleBrand.id === Number(this.props.selectedBrandId));
            if (brand) {
                this.updateEntityChannelConfigWithBrand(brand.meta);
            }
        }

        if (
            (
                this.props.selectOverrideBrandAdvancedOptions !== prevProps.selectOverrideBrandAdvancedOptions // eslint-disable-line max-len
            ) || (
                this.props.selectedBrandId !== prevProps.selectedBrandId && !this.props.selectOverrideBrandAdvancedOptions // eslint-disable-line max-len
            )
        ) {
            const brand = this.props.brands.find(singleBrand => singleBrand.id === Number(this.props.selectedBrandId));
            if (brand) {
                this.selectOverrideBrandAdvancedOptions(brand.meta);
            }
        }

        if (
            (
                this.props.selectOverrideBrandDisplayConfiguration !== prevProps.selectOverrideBrandDisplayConfiguration // eslint-disable-line max-len
            ) || (
                this.props.selectedBrandId !== prevProps.selectedBrandId && !this.props.selectOverrideBrandDisplayConfiguration // eslint-disable-line max-len
            )
        ) {
            const brand = this.props.brands.find(singleBrand => singleBrand.id === Number(this.props.selectedBrandId));
            if (brand) {
                this.selectOverrideBrandDisplayConfiguration(brand.meta);
            }
        }
    }

    updateEntityChannelConfigWithBrand(brandMeta) {
        // Only update the meta of the entity if there is an entity and a the flag is set
        if (!this.props.selectedOverrideBrandEnabledChannels && this.getEntityId()) {
            supportedChannelNamesList.forEach((channel) => {
                const key = `channelConfig.${channel}.enabled`;
                const value = get(brandMeta, key, false);
                this.props.change(`meta.${key}`, value);
            });
        }
    }

    selectOverrideBrandAdvancedOptions(brandMeta) {
        // Only update the meta of the entity if there is an entity and a the flag is set
        if (!this.props.selectOverrideBrandAdvancedOptions && this.getEntityId()) {
            for (const key of ['showTotalActivities', 'showTargetingTactics', 'enableObjectiveSwitching', 'showeCPAonSummaryDashboard', 'enforceSummaryOnlyDashboardView', 'showSemCpconv', 'showSocialCpconv', 'showFacebookDemographicData', 'showSocialExpandModules', 'showTtdSitesSummary']) {
                const value = get(brandMeta, key, false);
                this.props.change(`meta.${key}`, value);
            }
        }
    }

    selectOverrideBrandDisplayConfiguration(brandMeta) {
        // Only update the meta of the entity if there is an entity and a the flag is set
        if (!this.props.selectOverrideBrandDisplayConfiguration && this.getEntityId()) {
            const value = get(brandMeta, 'programmaticObjective.labelCode', '');
            this.props.change('meta.programmaticObjective.labelCode', value);
        }
    }

    render() {
        return (
            <EditEntityForm
                formName={formName}
                entityId={this.props.entityId}
                dispatch={this.props.dispatch}
                entityName={this.props.entityName}
                handleSubmit={this.props.handleSubmit.bind(null, updateEntityForm)}
                handleNewWorkOrder={this.props.addNewWorkOrderToEditForm}
                handleNewCustomChannel={this.props.addNewCustomChannelToEditForm}
                handleCloneExistingWorkOrder={this.props.cloneExistingWorkOrderToEditForm}
                handleOverrideRemoval={this.props.resetWorkOrderToMatchBrandEdit}
                switchWorkOrderPlatforms={this.props.switchAllWorkOrderPlatformsEdit}
                handleCancel={() => this.props.push(`/admin/entities/${this.props.entityId}`)}
                brands={this.props.brands}
                entityPlatform={get(this.props, 'initialValues.entityPlatform', ENTITY_PLATFORMS.default)}
                updateEntityChannelConfigWithBrand={this.updateEntityChannelConfigWithBrand}
                setAllChannelDataSources={this.setAllChannelDataSources}
                selectedProgrammaticObjective={this.props.selectedProgrammaticObjective}
                selectedLabelCode={this.props.selectedLabelCode}
                selectedBrandId={this.props.selectedBrandId}
                selectedOverrideBrandEnabledChannels={this.props.selectedOverrideBrandEnabledChannels}
                selectOverrideBrandAdvancedOptions={this.props.selectOverrideBrandAdvancedOptions}
                selectOverrideBrandDisplayConfiguration={this.props.selectOverrideBrandDisplayConfiguration}
                seededSalesforceId={this.props.seededSalesforceId}
                metaLoaded={this.props.metaLoaded} >
                {this.props.children}
            </EditEntityForm>
        );
    }
}

const formSelector = formValueSelector(formName);

const mapStateToProps = state => ({
    entityId: get(state.entities.entity, 'id'),
    entityName: get(state.entities.entity, 'name'),
    brands: state.brands.list,
    seededSalesforceId: get(state, 'router.parsedUrl.query.salesforceId'),
    metaLoaded: !!get(state, 'entities.entity.id'),
    initialValues: merge({}, {
        version: 2,
        meta: {
            spendMarkup: { type: 'percentage', value: 0 },
            channelConfig: getDefaultEnabledChannels(),
            overrideBrand: {
                enabledChannels: false,
                showTotalActivities: false,
                showTargetingTactics: false,
                enableObjectiveSwitching: false,
                showeCPAonSummaryDashboard: false,
                enforceSummaryOnlyDashboardView: false,
                showSemCpconv: false,
                showSocialCpconv: false,
                showSocialExpandModules: true,
                showFacebookDemographicData: false,
                showTtdSitesSummary: false
            }
        }
    }, state.entities.entity),
    selectedProgrammaticObjective: formSelector(state, 'meta.programmaticObjective.global'),
    selectedLabelCode: formSelector(state, 'meta.programmaticObjective.labelCode'),
    selectedBrandId: formSelector(state, 'brandId'),
    selectedOverrideBrandEnabledChannels: formSelector(state, 'meta.overrideBrand.enabledChannels'),
    selectOverrideBrandAdvancedOptions: formSelector(state, 'meta.overrideBrand.advancedOptions'),
    selectOverrideBrandDisplayConfiguration: formSelector(state, 'meta.overrideBrand.objectiveLabel')
});

const mergeProps = (stateProps, dispatchProps, ownProps) =>
    Object.assign({}, stateProps, dispatchProps, ownProps);

export default compose(
    connect(
        mapStateToProps,
        {
            fetchEntity,
            clearEntity,
            push,
            fetchBrandList,
            addNewWorkOrderToEditForm,
            addNewCustomChannelToEditForm,
            cloneExistingWorkOrderToEditForm,
            resetWorkOrderToMatchBrandEdit,
            clearSearchForOpportunities,
            switchAllWorkOrderPlatformsEdit,
        },
        mergeProps
    ),
    reduxForm({
        form: formName,
        enableReinitialize: true
    })
)(EditEntityContainer);



// WEBPACK FOOTER //
// ./src/containers/forms/EditEntityV2Container.js